import { generateUrlBase } from "../../../utils/utils";
import type { ApiCallerT } from "./types";
import type {
  IncidenceTypesApiT,
  GetAllIncidenceTypesResponseT,
} from "../types/incidenceTypes.types";

export const createIncidenceTypesApi = (
  apiCaller: ApiCallerT,
): IncidenceTypesApiT => ({
  getAll: async () => {
    const url = generateUrlBase("incidences");

    const response = await apiCaller<GetAllIncidenceTypesResponseT>(
      url,
      "GET",
      {},
      {},
      {},
    );

    return response;
  },
});
